import TipNDAStep from "./steps/TipNDAStep";
import ParteaDezvStep from "./steps/ParteaDezvStep";
import ParteaPrimStep from "./steps/ParteaPrimStep";
import DetaliiStep from "./steps/DetaliiStep";
import ConditiiStep from "./steps/ConditiiStep";
import PreviewStep from "./steps/PreviewStep";
import buildNDAPDF from "./buildPDF";

const ndaConfig = {
  buildPDF: buildNDAPDF,
  title: "NDA — Acord de Confidentialitate Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un acord de confidentialitate conform legislatiei din Romania",
  step1Benefit: "Protejează informațiile sensibile instant",
  pdfFilename: "acord-confidentialitate-nda.pdf",
  steps: [
    { id: "tip", label: "Tip NDA", title: "Tipul Acordului de Confidentialitate", icon: "\uD83D\uDD12", component: TipNDAStep },
    { id: "partea1", label: "Partea 1", title: "Partea care dezvaluie", icon: "\uD83D\uDC64", component: ParteaDezvStep },
    { id: "partea2", label: "Partea 2", title: "Partea care primeste", icon: "\uD83D\uDC65", component: ParteaPrimStep },
    { id: "detalii", label: "Detalii", title: "Detalii Confidentialitate", icon: "\uD83D\uDCCB", component: DetaliiStep },
    { id: "conditii", label: "Conditii", title: "Conditii Suplimentare", icon: "\u2696\uFE0F", component: ConditiiStep },
    { id: "preview", label: "Preview", title: "Previzualizare NDA", icon: "\uD83D\uDCC4", component: PreviewStep },
  ],
  defaultData: {
    bilateral: false,
    // Partea 1
    partea1Tip: "srl",
    partea1Nume: "",
    partea1Adresa: "",
    partea1CNP: "",
    partea1CI: "",
    partea1Denumire: "",
    partea1CUI: "",
    partea1RegCom: "",
    partea1Sediu: "",
    partea1Reprezentant: "",
    partea1Titular: "",
    // Partea 2
    partea2Tip: "pf",
    partea2Nume: "",
    partea2Adresa: "",
    partea2CNP: "",
    partea2CI: "",
    partea2Denumire: "",
    partea2CUI: "",
    partea2RegCom: "",
    partea2Sediu: "",
    partea2Reprezentant: "",
    partea2Titular: "",
    // Detalii
    scop: "",
    confTehnice: true,
    confFinanciare: true,
    confClienti: false,
    confStrategii: false,
    confCod: false,
    confDate: false,
    confAltele: false,
    confAlteleText: "",
    durataObligatie: "2",
    durataAcord: "colaborare",
    // Conditii
    penalitati: false,
    penalitateSuma: "",
    penalitateMoneda: "EUR",
    instanta: "dezvaluie",
    dataSemnare: new Date().toISOString().split("T")[0],
  },
  validate: (stepId, data) => {
    const errors = {};

    function validateParty(prefix) {
      if (data[`${prefix}Tip`] === "pf") {
        if (!data[`${prefix}Nume`].trim()) {
          errors[`${prefix}Nume`] = "Numele este obligatoriu";
        } else if (data[`${prefix}Nume`].trim().split(/\s+/).length < 2) {
          errors[`${prefix}Nume`] = "Introduceti numele complet (nume si prenume)";
        }
        if (!data[`${prefix}Adresa`].trim()) errors[`${prefix}Adresa`] = "Adresa este obligatorie";
        if (data[`${prefix}CNP`].trim() && !/^\d{13}$/.test(data[`${prefix}CNP`].trim())) {
          errors[`${prefix}CNP`] = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data[`${prefix}CI`].trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data[`${prefix}CI`].trim())) {
          errors[`${prefix}CI`] = "Format invalid (ex: RD 123456)";
        }
      } else if (data[`${prefix}Tip`] === "pfa") {
        if (!data[`${prefix}Denumire`].trim()) errors[`${prefix}Denumire`] = "Denumirea PFA este obligatorie";
        if (!data[`${prefix}CUI`].trim()) errors[`${prefix}CUI`] = "CUI-ul este obligatoriu";
        if (!data[`${prefix}Sediu`].trim()) errors[`${prefix}Sediu`] = "Sediul profesional este obligatoriu";
        if (!data[`${prefix}Titular`].trim()) {
          errors[`${prefix}Titular`] = "Numele titularului este obligatoriu";
        } else if (data[`${prefix}Titular`].trim().split(/\s+/).length < 2) {
          errors[`${prefix}Titular`] = "Introduceti numele complet (nume si prenume)";
        }
        if (data[`${prefix}CNP`].trim() && !/^\d{13}$/.test(data[`${prefix}CNP`].trim())) {
          errors[`${prefix}CNP`] = "CNP-ul trebuie sa contina exact 13 cifre";
        }
      } else if (data[`${prefix}Tip`] === "srl") {
        if (!data[`${prefix}Denumire`].trim()) errors[`${prefix}Denumire`] = "Denumirea societatii este obligatorie";
        if (!data[`${prefix}CUI`].trim()) errors[`${prefix}CUI`] = "CUI-ul este obligatoriu";
        if (!data[`${prefix}Sediu`].trim()) errors[`${prefix}Sediu`] = "Sediul social este obligatoriu";
        if (!data[`${prefix}Reprezentant`].trim()) {
          errors[`${prefix}Reprezentant`] = "Reprezentantul legal este obligatoriu";
        } else if (data[`${prefix}Reprezentant`].trim().split(/\s+/).length < 2) {
          errors[`${prefix}Reprezentant`] = "Introduceti numele complet (nume si prenume)";
        }
      }
    }

    if (stepId === "partea1") validateParty("partea1");
    if (stepId === "partea2") validateParty("partea2");

    if (stepId === "detalii") {
      if (!data.scop.trim()) errors.scop = "Scopul acordului este obligatoriu";
      const hasAny = data.confTehnice || data.confFinanciare || data.confClienti ||
        data.confStrategii || data.confCod || data.confDate || data.confAltele;
      if (!hasAny) errors.confInfo = "Selecteaza cel putin un tip de informatii confidentiale";
    }

    if (stepId === "conditii") {
      if (data.penalitati && (!data.penalitateSuma || Number(data.penalitateSuma) <= 0)) {
        errors.penalitateSuma = "Suma penalitatii este obligatorie";
      }
    }

    return errors;
  },
};

export default ndaConfig;
